import CancelledReservationModal from './CancelledReservationModal';

export default CancelledReservationModal;
